// extracted by mini-css-extract-plugin
export default {"layout":"layout_XgLPJzm","layout_stretch":"layout_stretch_N4Ixprl","layout_large":"layout_large_mDODgVT","layout_small":"layout_small_LY45bnL"};